module.exports = __webpack_public_path__ + "img/cloud-fill.4fee9f1c.svg";